import * as React from "react"
import {
  type ActionItemFieldsFragment,
  type IntervalOrigin,
  ObjectKind,
} from "@digits-graphql/frontend/graphql-bearer"

/**
 * INTERFACES
 */

export type GroupView = keyof typeof Groups
export enum Groups {
  Assigned = "Assigned",
  Watched = "Watched",
  Open = "Open",
  Resolved = "Resolved",
}

export enum InboxTab {
  All = "All",
  Transactions = "Transactions",
  Bills = "Bills",
  Reports = "Reports",
  Categories = "Categories",
  Parties = "Parties",
  Reconciliations = "Reconciliations",
}

export const INBOX_TAB_OBJECT_KINDS = new Map<InboxTab, ObjectKind[]>([
  [InboxTab.Transactions, [ObjectKind.Transaction, ObjectKind.LedgerTransaction]],
  [InboxTab.Bills, [ObjectKind.Bill]],
  [InboxTab.Reports, [ObjectKind.ReportPackage]],
  [InboxTab.Categories, [ObjectKind.Category]],
  [InboxTab.Parties, [ObjectKind.Party]],
  [InboxTab.Reconciliations, [ObjectKind.Reconciliation]],
])

export interface InboxContextProps {
  tab: InboxTab
  groupView: GroupView
  setGroupView: React.SetState<GroupView>
  changeInboxOrigin: React.SetState<IntervalOrigin>
}

/**
 * CONTEXT
 */

export const InboxContext = React.createContext<InboxContextProps>({
  tab: InboxTab.All,
  groupView: "Assigned",
  setGroupView: () => {},
  changeInboxOrigin: () => {},
})

export function useInboxContext() {
  return React.useContext(InboxContext)
}

export function useGroupView() {
  return useInboxContext().groupView
}

export function useHasActionButtons() {
  return useGroupView() !== "Resolved"
}

/**
 * LEGACY
 */

export type ActionItemType = "AllActionItems" | ActionItemFieldsFragment["value"]["__typename"]
export const LEGACY_ACTION_ITEM_TYPES: readonly ActionItemType[] = [
  "ActionItemTransaction",
  "ActionItemBillApproval",
  "ActionItemPublishedReport",
  "ActionItemThread",
]
